import angular from 'angular';
import {ManagerApiModule} from '../../../api/manager-api.module';
import {PasswordStrengthIndicatorComponent} from './password-strength-indicator';
import {PasswordStrengthBounds} from './constants/constants';

export const PasswordStrengthIndicatorModule = angular.module('buildium.manager.components.password', [
    ManagerApiModule.name
])
    .component('bdPasswordStrengthIndicator', PasswordStrengthIndicatorComponent)
    .constant('PASSWORD_STRENGTH_BOUNDS', PasswordStrengthBounds);
